"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.asyncIterableSplitOnAnySubseq = asyncIterableSplitOnAnySubseq;

var _asyncSpliterator = require("../../../internal/async-spliterator");

var _circularBuffer = require("../../../internal/circular-buffer");

var _iterableStartsWith_ = require("../../$starts-with_/iterable-starts-with_");

var _asyncMap = _interopRequireDefault(require("../../$map/async-map"));

var _asyncToArray = _interopRequireDefault(require("../../$to-array/async-to-array"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const startsWithConfig = {
  any: false,
  subseq: true
};

class AsyncAnySubseqSpliterator extends _asyncSpliterator.AsyncSpliterator {
  constructor(sourceIterator, separatorSubseqs) {
    super(sourceIterator);
    const maxMatchLength = separatorSubseqs.reduce((max, {
      length
    }) => Math.max(max, length), 1);
    this.separatorSubseqs = separatorSubseqs;
    this.buffer = new _circularBuffer.CircularBuffer(maxMatchLength);
  }

  static async nullOrInstance(sourceIterator, separatorSubseqs) {
    const inst = new AsyncAnySubseqSpliterator(sourceIterator, separatorSubseqs);
    return (await inst._isEmpty()) ? null : inst;
  }

  async _isEmpty() {
    let item;

    if (!(item = await super.next()).done) {
      this.buffer.push(item.value);
    }

    return item.done;
  }

  getMatchingLength() {
    for (const subsequence of this.separatorSubseqs) {
      if ((0, _iterableStartsWith_.iterableStartsWith_)(this.buffer, startsWithConfig, subsequence)) {
        return subsequence.length;
      }
    }

    return 0;
  }

  async next() {
    let item;

    while (!(this.buffer.isFull() || (item = await super.next()).done)) {
      this.buffer.push(item.value);
    }

    if (!this.buffer.size) {
      return {
        value: undefined,
        done: true
      };
    } else {
      const matchingLength = this.getMatchingLength(this.buffer, this.separatorSubseqs);

      if (matchingLength) {
        for (let i = 0; i < matchingLength; i++) {
          this.buffer.shift();
        }
      }

      return {
        value: matchingLength ? _asyncSpliterator.split : this.buffer.shift(),
        done: false
      };
    }
  }

}

async function* asyncIterableSplitOnAnySubseq(source, separatorSubseqs) {
  const _separatorSubseqs = (await (0, _asyncToArray.default)((0, _asyncMap.default)(_asyncToArray.default, separatorSubseqs))).filter(subseq => subseq.length).sort((a, b) => b.length - a.length);

  yield* new _asyncSpliterator.AsyncPartsIterator((await AsyncAnySubseqSpliterator.nullOrInstance(source[Symbol.asyncIterator](), _separatorSubseqs)));
}